module.exports = __webpack_public_path__ + "img/email_off.496e5b35.svg";